import { Stack, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import Button from './Button';
import firebase from '../firebase';
import UserCredential = firebase.auth.UserCredential;

export const reSendCodeStyle = {
    textAlign: 'center' as 'center', 
    margin: '1em 0', 
    fontWeight: '700', 
    color: '#6D6E71', 
    cursor: 'pointer', 
    fontFamily: 'Lato'
}

export const verificationTextStyle = {
    fontFamily: 'Lato', 
    fontWeight: '400',
    margin: '1em 0'
}
 
type props = {
    phoneNumber : string
}

const VerificationCode : React.FC<props> = (props) => {

    const [verificationCode, setVerificationCode] = useState<string>('')


    /**
     * Function sets up an invisible recaptcha verifier to use for sending
     * verification codes.
     */
    const setUpRecaptcha = (): void => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
        size: 'invisible',
        callback: function (response: any): void {
            console.log('Captcha Resolved');
        },
        defaultCountry: 'US'
        });
    };

    useEffect(() => {
        setUpRecaptcha()
    }, [])

    /**
	 * Function that is triggered when the user clicks continue after entering the confirmation code sent to their
	 * phone. The code is checked to make sure it is a valid verification code since so far only text entry fields can
	 * be limited to a certain length of characters. If an invalid verification code is entered an alert will pop up and
	 * ask the user to enter a valid verification code.
	 * @param e
	 */

	const onCodeSubmit = (e: any): void => {
		e.preventDefault();
		if (!/^\d+$/.test(verificationCode)) {
			alert('You must enter a valid verification code');
			return;
		}
		const otp = verificationCode;
		console.log(otp);
		console.log('Using confirmation result (next line)');
		console.log(window.confirmationResult.verificationId);
		window.confirmationResult
			.confirm(otp)
			.then(function (result: UserCredential) {
				const user = result.user;
				console.log('User is signed in with Phone');
				console.log(user);
			})
			.catch(function (error: Error) {
				console.log(error);
				alert('Incorrect Verification Code');
			});
	};

    const reSendCode = (e : any) => {
        e.preventDefault();
        setUpRecaptcha();
        if (
            !/^\d+$/.test(props.phoneNumber)
        ) {
            alert('You must enter a valid phone number');
            return;
        }
        const phone = props.phoneNumber;
        const appVerifier = window.recaptchaVerifier;
        firebase
            .auth()
            .signInWithPhoneNumber(phone, appVerifier)
            .then((confirmationResult) => {
                console.log('confirmationResult', confirmationResult)
                // SMS sent. Prompt user to type the code from the message, then sign the
                // user in with confirmationResult.confirm(code).
                console.log('OTP is sent');
                window.confirmationResult = confirmationResult;
                // props.setIsVerified(true)
            })
            .catch(function (error: Error) {
                console.log(error);
                window.recaptchaVerifier.render();
                return;
        });
    }

    return (
        <Stack>
		<div id={'recaptcha-container'}></div>

        <Typography style={verificationTextStyle}>
            Please enter the verification code we just sent to <span style={{fontWeight: '700'}}>{props.phoneNumber}</span> 
        </Typography>

        <form onSubmit={onCodeSubmit}>
        <TextField 
            id="outlined-basic"
            label="Verification Code" 
            variant="outlined" 
            style={{width: '100%'}}
            value={verificationCode}
            onChange={function(e){
                setVerificationCode(e.target.value)
            }}
        />

        <Typography 
            style={reSendCodeStyle}
            onClick={reSendCode}
        >
            Resend Code
        </Typography>

        <Button fontColor={'#FFFFFF'} disable={verificationCode.length === 6 ? false : true} backgroundColor={verificationCode.length === 6 ? '#FF3363' : '#DADBDB'} borderColor={'#DADBDB'} >
            Continue
        </Button>
        </form>
        </Stack>
    )
}

export default VerificationCode